import {Repository} from "../../persistence/repository";
import {EmployeeToIssueAssignment} from "../entities/employee-to-issue-assignment.entity";
import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {plainToInstance} from "class-transformer";
import {EmployeeToIssueAssignmentDto} from "../dtos/employee-to-issue-assignment.dto";
import {Issue} from "../entities/issue.entity";
import {Employee} from "../entities/employee.entity";
import {EntityState} from "../../persistence/entity-state.enum";
import {ChangeTracker} from "../../change-tracking/change-tracker";
import {ShortIdHelper} from "../../helpers/short-id.helper";

@singleton()
@persistence({entity: EmployeeToIssueAssignment})
export class EmployeeToIssueAssignmentRepository extends Repository<EmployeeToIssueAssignment> {

    public create(issue: Issue | null, employee: Employee | null): Promise<EmployeeToIssueAssignment | null> {

        const assignment = plainToInstance(EmployeeToIssueAssignment, <EmployeeToIssueAssignmentDto>{
            uid: ShortIdHelper.generate(),
            issue: issue?.uid ?? null,
            employee: employee?.uid ?? null,
            timeBudget: 60
        });

        const assignmentProxy = ChangeTracker.create(assignment);

        this.entityManager.setLoadedEntity(assignmentProxy, EntityState.NEW);

        return Promise.resolve(assignmentProxy);
    }

    public fromDto(dto: EmployeeToIssueAssignmentDto): EmployeeToIssueAssignment {
        const assignmentProxy = plainToInstance(EmployeeToIssueAssignment, dto);

        this.entityManager.setLoadedEntity(assignmentProxy, EntityState.PERSISTED);

        return assignmentProxy;
    }
}